import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/formatApiError";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Reçoit #session_id=... après Google : échange contre notre session puis redirige.
export const GoogleAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { startSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const inviteToken = location.pathname === "/accept-invite" ? new URLSearchParams(location.search).get("token") : null;
    const backTo = inviteToken ? `/accept-invite?token=${inviteToken}` : "/login";
    const run = async () => {
      try {
        const { data } = inviteToken
          ? await axios.post(`${API}/orgs/accept-invite/google`, { session_id: sessionId, token: inviteToken })
          : await axios.post(`${API}/auth/google`, {
              session_id: sessionId,
              remember_me: sessionStorage.getItem("google_remember_me") === "1",
            });
        startSession(data);
        toast.success(inviteToken ? "Invitation acceptée, bienvenue !" : "Connexion réussie");
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err, "Connexion Google impossible"));
        navigate(backTo, { replace: true });
      } finally {
        sessionStorage.removeItem("google_remember_me");
      }
    };
    run();
  }, [location, navigate, startSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="google-auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};
